import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import ChevronLeft from '@/assets/icon-chevron-left.svg?react';
import { getBackDestination } from '@/core/utils/routing';

interface Props extends React.HTMLAttributes<HTMLElement> {
    className?: string;
}

function BackLink(props: Props) {
    const windowLocation = useLocation();
    const navigate = useNavigate();

    const goBack = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        navigate(getBackDestination(windowLocation.pathname));
    };

    const element = (
        <div className="flex align-center d-lg-none">
            <button
                type="button"
                className={`text-dark ${props?.className || ''} ${getBackDestination(windowLocation.pathname) ? '' : 'invisible'
                }`}
                style={{ lineHeight: 1, background: 'transparent' }}
                onClick={(event) => goBack(event)}
            >
                <ChevronLeft />
            </button>
        </div>
    );

    return element;
}

export default BackLink;
